
document.getElementById('validate-form').addEventListener('submit', (e) => {
  e.preventDefault();
  const form = e.target;
  form.querySelectorAll('.form-control').forEach((el) => {
    el.classList.remove('is-invalid');
    const next = el.nextElementSibling;
    if (next && next.classList.contains('form-error')) next.remove();
    if (!el.checkValidity()) {
      el.classList.add('is-invalid');
      const msg = document.createElement('div');
      msg.className = 'form-error';
      msg.textContent = el.validationMessage;
      el.after(msg);
    }
  });
});
